import {
  LaptopUser,
  Legal,
  TabHelp,
  CareForOthers,
  FaceToFace,
  ManagerSupport,
  Child,
  Umbrella,
  Target,
  AppleFruit,
} from 'icons';
import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

type IconBaseProps = React.SVGProps<SVGSVGElement> & {
  primaryColor?: string;
};

const createHelpIcon = (
  IconComponent: React.ComponentType<IconBaseProps>,
) => styled(IconComponent).attrs(({ theme }) => ({
  primaryColor: theme.colors.text.primary,
  ['aria-hidden']: true,
}))`
  width: ${rem(16)};
  height: ${rem(16)};
`;

const SupportIcon = createHelpIcon(TabHelp);
const LaptopUserIcon = createHelpIcon(LaptopUser);
const LegalIcon = createHelpIcon(Legal);
const CareForOthersIcon = createHelpIcon(CareForOthers);
const FaceToFaceIcon = createHelpIcon(FaceToFace);
const ManagerSupportIcon = createHelpIcon(ManagerSupport);
const ChildIcon = createHelpIcon(Child);
const AppleIcon = createHelpIcon(AppleFruit);
const UmbrellaIcon = createHelpIcon(Umbrella);
const TargetIcon = createHelpIcon(Target);

const iconLookupMap: Record<string, ReturnType<typeof createHelpIcon>> = {
  'critical-incident': LaptopUserIcon,
  'face-to-face': FaceToFaceIcon,
  'financial-and-legal': LegalIcon,
  'immediate-support': SupportIcon,
  'manager-support': ManagerSupportIcon,
  'care-for-others': CareForOthersIcon,
  'under-18': LaptopUserIcon,
  'practical-support': UmbrellaIcon,
  child: ChildIcon,
  wellness: AppleIcon,
  life: TargetIcon,
};

export const HelpIcon = ({ icon }: { icon: string }) => {
  const Icon = iconLookupMap[icon] || SupportIcon;

  return <Icon />;
};
